import styled, { css } from 'styled-components';
import CurrencyInput from 'react-currency-input-field';

interface IContainerProps {
  isFocused: boolean;
  isErrored?: boolean;
}

export const Label = styled.label<IContainerProps>`
  ${({ theme, isFocused }) => css`
    font-size: ${theme.fontSizes.label};
    color: ${theme.colors.labelInput};

    ${isFocused &&
    css`
      color: ${theme.colors.primary};
    `}
  `}
`;

export const Container = styled.div<IContainerProps>`
  ${({ theme, isFocused, isErrored }) => css`
    width: 100%;
    display: flex;
    background: ${theme.colors.lightGrey};
    border-radius: ${theme.radius.small};
    padding: 10px;
    border: 1px solid ${theme.colors.inputBorder};
    align-items: center;

    ${isFocused &&
    css`
      border: 1px solid ${theme.colors.primary};
      color: ${theme.colors.primary};
    `}

    ${isErrored &&
    css`
      border: 1px solid ${theme.colors.error};
    `}
  `}
`;

export const InputText = styled(CurrencyInput)`
  ${({ theme }) => css`
    flex: 1;
    border: 0;
    background: transparent;
    font-size: ${theme.fontSizes.input};
  `}
`;
